import { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import { hasSettingsEnabled } from '~/lib/navigationPermissions';
import { Logout } from '~/modules/auth/components/Logout';
import { RefreshAuth } from '~/modules/auth/components/RefreshAuth';
import { SecureRoute } from '~/modules/auth/components/SecureRoute';
import { useUser } from '~/modules/auth/hooks/useUser';
import { AuthRouter } from '~/modules/auth/router';
import { BrandContext } from '~/modules/branding';
import { LinkFarmRouter } from '~/modules/link-farm/router';
import { RemoteRouter } from '~/modules/remotes/router';

import { ErrorPage } from './components/ErrorPage';
import { App as RosterApp } from './modules/artist-roster/App';
import { App as CampaignPlannerApp } from './modules/campaign-planner/App';
import { App as DdexConsoleApp } from './modules/ddex-console/App';
import { App as LabelPerfApp } from './modules/label-perf/App';
import { CatalogApp } from './modules/label-perf/catalog/CatalogApp';
import { App as ProfileApp } from './modules/my-profile/App';
import { PrimaryLayout } from './modules/navigation/components/PrimaryLayout';
import { App as SettingsApp } from './modules/settings/App';

/**
 * Top-level router combining module-level routers
 */
const Router = () => {
  const brand = useContext(BrandContext);
  const { features } = useUser();
  const canAccessSettings = hasSettingsEnabled(features);

  const rootRoute =
    brand.name === 'WMG' ? <LinkFarmRouter /> : <RemoteRouter />;

  return (
    <Routes>
      <Route path="login/*" element={<AuthRouter />} />
      <Route element={<SecureRoute />}>
        <Route path="logout" element={<Logout />} />
        <Route path="auth/refresh" element={<RefreshAuth />} />
        <Route element={<PrimaryLayout />}>
          <Route path="*" element={rootRoute} />
          <Route
            path="settings/*"
            element={
              canAccessSettings ? (
                <SettingsApp />
              ) : (
                <ErrorPage type="noAccessPage" />
              )
            }
          />
          <Route path="roster/*" element={<RosterApp />} />
          <Route path="marketing/planner" element={<CampaignPlannerApp />} />
          <Route path="label/*" element={<LabelPerfApp />} />
          <Route path="catalog/*" element={<CatalogApp />} />
          {canAccessSettings ? (
            <Route path="my-profile-2/*" element={<ProfileApp />} />
          ) : null}
          <Route path="release/ddex/*" element={<DdexConsoleApp />} />
        </Route>
      </Route>
    </Routes>
  );
};

Router.displayName = 'Router';

export { Router };
